import { postApi } from "./api_instance";

export const otpRequest = async ({ email, userType }, dispatch) => {
  try {
    const { data } = await postApi({
      apiUrl: "/api/user/signup/generateotp",
      dispatch,
      data: { email, user_type: userType },
    });
    return data;
  } catch (error) {
    throw error;
  }
};
